import React from 'react';
import Select from 'react-select';
import { useTheme } from '../context/ThemeContext';

const CustomSelect = ({ 
  label, 
  options, 
  value, 
  onChange, 
  placeholder, 
  isRequired = false,
  isSearchable = true,
  isClearable = true,
  className = "",
  ...props 
}) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const customStyles = {
    control: (base, state) => ({
      ...base,
      border: `1px solid ${isDark ? '#4b5563' : '#d1d5db'}`,
      borderRadius: '0.5rem',
      padding: '0.5rem 0.75rem',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      backgroundColor: isDark ? '#111827' : 'white',
      boxShadow: state.isFocused
        ? `0 0 0 3px rgba(244, 63, 94, ${isDark ? '0.35' : '0.15'})`
        : 'none',
      borderColor: state.isFocused ? '#f43f5e' : (isDark ? '#4b5563' : '#d1d5db'),
      '&:hover': {
        borderColor: '#f43f5e',
      },
      transition: 'all 0.2s',
    }),
    valueContainer: (base) => ({
      ...base,
      padding: 0,
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
      color: isDark ? '#e5e7eb' : '#374151',
    }),
    placeholder: (base) => ({
      ...base,
      color: isDark ? '#9ca3af' : '#9ca3af',
    }),
    menu: (base) => ({
      ...base,
      borderRadius: '0.5rem',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.35)',
      border: `1px solid ${isDark ? '#4b5563' : '#e5e7eb'}`,
      marginTop: '0.25rem',
      zIndex: 50,
    }),
    menuList: (base) => ({
      ...base,
      padding: '0.25rem',
      borderRadius: '0.5rem',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused
        ? (isDark ? '#111827' : '#fef2f2')
        : (isDark ? '#111827' : 'white'),
      color: state.isFocused
        ? '#f43f5e'
        : (isDark ? '#e5e7eb' : '#374151'),
      padding: '0.75rem 1rem',
      borderRadius: '0.375rem',
      margin: '0.125rem',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: isDark ? '#111827' : '#fef2f2',
        color: '#f43f5e',
      },
      transition: 'all 0.2s',
    }),
    singleValue: (base) => ({
      ...base,
      color: isDark ? '#e5e7eb' : '#374151',
    }),
  };

  return (
    <div className={`space-y-2 ${className}`}>
      {label && (
        <label className="block text-sm font-medium text-gray-700">
          {label}
          {isRequired && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <Select
        value={value}
        onChange={onChange}
        options={options}
        placeholder={placeholder || `Select ${label?.toLowerCase() || 'an option'}`}
        styles={customStyles}
        isSearchable={isSearchable}
        isClearable={isClearable}
        classNamePrefix="react-select"
        {...props}
      />
    </div>
  );
};

export default CustomSelect;
